<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64">
    <g fill="none" fill-rule="evenodd">
        <g fill="#000">
            <g>
                <path class="fill" d="M22.114 46.114c-1.041 1.042-1.041 2.73 0 3.772 1.042 1.041 2.73 1.041 3.772 0l16-16c1.041-1.042 1.041-2.73 0-3.772l-16-16c-1.042-1.041-2.73-1.041-3.772 0-1.041 1.042-1.041 2.73 0 3.772L36.23 32 22.114 46.114z" transform="translate(-642 -751) translate(642 751)"/>
            </g>
        </g>
    </g>
</svg>
